import publicUrls from "../../routes/publicUrls";
import React, { useState } from "react";
import { Box, IconButton, InputBase, useMediaQuery } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

import LogoImg from "../../images/resources/dddd.png";
import Menu from "./Menu";
import LanguageSelector from "./LanguageSelector";
import GalleryScope from "../../theme/GalleryScope";
import { tokens } from "../../theme/galleryTheme";



const UTILITY_LINKS = [
  { label: "About", href: "/about" },
  { label: "Contact us", href: publicUrls.contact() },
  { label: "How to buy", href: "/how-to-buy" },
  { label: "How to sell", href: "/how-to-sell" },
  { label: "FAQ", href: "/faq" },
];

const utilityLinkSx = {
  color: tokens.color.secondary,
  fontSize: "0.8125rem",
  fontWeight: 500,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  textDecoration: "none",
  display: "inline-flex",
  alignItems: "center",
  minHeight: 36,
  background: "none",
  border: 0,
  p: 0,
  cursor: "pointer",
  fontFamily: "inherit",
  "&:hover": { color: tokens.color.ink, textDecoration: "underline", textUnderlineOffset: "4px" },
};

const Header = () => {
  const isMobile = useMediaQuery("(max-width:1199px)");
  const [token] = useState(localStorage.getItem("token") || "");
  const [search, setSearch] = useState("");

  const ClickLogOut = () => {
    localStorage.clear();
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) window.location.href = `/search/${search.trim()}`;
  };

  return (
    <GalleryScope>
      <Box
        component="header"
        className="lg-gallery lg-site-header"
        sx={{
          width: "100%",
          bgcolor: "#fff",
          position: "sticky",
          top: 0,
          zIndex: 1200,
          borderBottom: `1px solid ${tokens.color.line}`,
        }}
      >
        
        {!isMobile && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: { lg: 4, xl: 6 },
              bgcolor: tokens.color.ivory,
              borderBottom: `1px solid ${tokens.color.line}`,
            }}
          >
            <Box component="nav" aria-label="Information">
              <Box component="ul" sx={{ display: "flex", gap: 3, listStyle: "none", m: 0, p: 0 }}>
                {UTILITY_LINKS.map((link) => (
                  <li key={link.href}>
                    <Box component="a" href={link.href} sx={utilityLinkSx}>
                      {link.label}
                    </Box>
                  </li>
                ))}
              </Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
              {token ? (
                <>
                  <Box component="a" href="/my/account" sx={utilityLinkSx}>
                    My account
                  </Box>
                  <Box component="button" type="button" onClick={ClickLogOut} sx={utilityLinkSx}>
                    Log out
                  </Box>
                </>
              ) : (
                <Box component="a" href="/login" sx={{ ...utilityLinkSx, color: tokens.color.ink, fontWeight: 600 }}>
                  Sign in
                </Box>
              )}
              <LanguageSelector />
            </Box>
          </Box>
        )}

        
        <Box
          className="lg-header-main"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: { lg: 2, xl: 3 },
            px: isMobile ? 1 : { lg: 4, xl: 6 },
            minHeight: isMobile ? 64 : 76,
          }}
        >
          {isMobile && <Menu isMobile={true} ClickLogOut={ClickLogOut} />}

        <Box
        component="a"
        href="/home"
        aria-label="León Gallery — home"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: isMobile ? "absolute" : "static",
          left: isMobile ? "50%" : "auto",
          top: isMobile ? "50%" : "auto",
          transform: isMobile ? "translate(-50%, -50%)" : "none",
          zIndex: 1,
        }}
      >
        <img
          src={LogoImg}
          alt="León Gallery"
          style={{
            height: isMobile ? 52 : 46,
            width: "auto",
            display: "block",
          }}
        />
      </Box>
          {!isMobile && (
            <Box sx={{ flex: "1 1 auto", minWidth: 0, display: "flex", justifyContent: "center" }}>
              <Menu isMobile={false} />
            </Box>
          )}

          
          {!isMobile && (
            <Box
              component="form"
              role="search"
              onSubmit={handleSearch}
              sx={{
                flex: "0 1 260px",
                minWidth: 150,
                display: "flex",
                alignItems: "center",
                borderBottom: `1px solid ${tokens.color.ink}`,
                "&:focus-within": { borderBottomWidth: 2 },
              }}
            >
              <label htmlFor="site-search" className="lg-sr-only">
                Search artists, works or auctions
              </label>
              <InputBase
                id="site-search"
                placeholder="Search artists, works, auctions"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                inputProps={{ type: "search" }}
                sx={{
                  flex: 1,
                  fontSize: "0.9375rem",
                  color: tokens.color.ink,
                  "& input": { py: 1 },
                  "& input::placeholder": { color: tokens.color.muted, opacity: 1 },
                }}
              />
              <IconButton type="submit" aria-label="Search" sx={{ color: tokens.color.ink, width: 44, height: 44 }}>
                <SearchIcon fontSize="small" />
              </IconButton>
            </Box>
          )}

          
          {isMobile && (
  <Box
    sx={{
      position: "absolute",
      right: 8,
      top: "50%",
      transform: "translateY(-50%)",
      display: "flex",
      alignItems: "center",
      zIndex: 2,
    }}
  >
    <LanguageSelector compact />

    <IconButton
      component="a"
      href={token ? "/my/account" : "/login"}
      aria-label={token ? "My account" : "Sign in"}
      sx={{
        color: tokens.color.ink,
        width: 48,
        height: 48,
      }}
    >
      <PersonOutlineIcon />
    </IconButton>
  </Box>
)}
        </Box>
      </Box>
    </GalleryScope>
  );
};

export default Header;
